const RECENT_BEFOREUNLOAD_MS = 1_000;

let lastBeforeUnloadAt = Number.NEGATIVE_INFINITY;
let hidden = false;

window.addEventListener('beforeunload', () => {
  lastBeforeUnloadAt = Date.now();
});

window.addEventListener('pagehide', () => {
  hidden = true;
});

window.addEventListener('pageshow', () => {
  hidden = false;
});

/**
 * True while the page is leaving: a `beforeunload` fired up to a second ago,
 * or a `pagehide` fired with no `pageshow` since.
 */
export const isPageLeaving = (): boolean =>
  hidden || Date.now() - lastBeforeUnloadAt <= RECENT_BEFOREUNLOAD_MS;
